module.exports = __webpack_public_path__ + "img/DESC.ec07c48e.svg";